const middlewareUrl = process.env.REACT_APP_MIDDLEWARE_URL;
const technicalWork = process.env.REACT_APP_TECHNICAL_WORK;

export { middlewareUrl, technicalWork };
